<template>
    <div class="modal fade" id="replyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Email Message</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>
                    <div class="alert alert-danger" role="alert" v-if="errorMessage">
                        {{ errorMessage }}
                    </div>
                    <label>Message Body : </label>

                    <ckeditor v-model="form.message_body"
                              tag-name="textarea"
                              value=""
                              :config="editorConfigMin"></ckeditor>
                    <br>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="add-attachment">
                                <div class="add-attchmnt">

                                    <div class="form-group files vendor_mail_files color" >
                                        <vue-dropzone :options="dropzoneOptions"
                                                      :id="'item-dropzone-attach'"
                                                      v-on:vdropzone-sending="sendingEventQuoteAttachments"
                                                      v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                        </vue-dropzone>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="add_user_mail_attached">

                    </div>
                    <div id="add_user_mail">
                        <template v-for="(item, index) in form.files">
                            <div class="pdf-dwn-sec line-hgt">
                                <img :src="'/message_files/'+item.name" style="width:70px;height:70px" >{{item.name}}
                                <a class="fa fa-trash-alt fa-pull-right trash_btn" @click="deleteAttachFile(index)"></a>
                                <a :href="'/message_files/'+item.name" class="fa fa-download fa-pull-right" >download</a>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-footer" style="display: flex;">
                    <div class="row">
                        <div class="col-sm-6 text-left">
                            <button type="button" @click="sendMail" class="btn btn-blue" id="reply_mail_btn">
                                <span class="send_text">Send&nbsp;</span>
                                <span v-if="loading" class="btn-icon-spinner">Sending&nbsp;<i class="fa fa-spinner btn-load-animate"></i></span>
                            </button>
                        </div>
                        <div class="col-sm-6 text-right">
                            <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {debounce} from 'lodash';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VendorAddModal from "./VendorAddModal";
import InputTag from 'vue-input-tag';

export default {
    name: "QuoteMessageReplyModal",
    props: ['quotation', 'userType', 'customer', 'vendor', 'prevVersionMailData'],
    components: {
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            form: {
                message_body: "",
                attached_files: [],
                attachmentIds: [],
                files: []
            },
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            dropzoneOptions: {
                url: window.route('addMessageAttachment'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),

        deleteVendorFile(index){
            // this.vendor_files.splice(id, 1);
            this.form.vendor_files.splice(index, 1);
        },
        deleteAttachFile(id, index){
            // this.vendor_files.splice(id, 1);
            this.form.files.splice(index, 1);
            this.form.attached_files.splice(index, 1);
            this.form.attachmentIds.splice(index, 1);
        },
        sendingEventQuoteAttachments(file, xhr, formData){
            // formData.append('quote_id', this.quotation.id);
        },
        afterUploadComplete(file, response) {
            if(response.success==true){
                console.log(response)
                this.form.files.push(response);
                this.form.attached_files.push(response.name);
                this.form.attachmentIds.push(response.attachment_id);
            } else {
                this.setErrorMessage('File not uploaded successfully');
            }
        },
        sendMail(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let form = _.cloneDeep(self.form);

            let apiUrl = window.route('send_cus_mail');

            let payload = {
                customer_email: this.customer && this.customer.data && this.customer.data.length ? this.customer.data[0].customer_contact_email : null,
                customer_name: this.customer && this.customer.data && this.customer.data.length ? this.customer.data[0].contact_name : null,
                quote_num: this.quotation.quotation_number,
                quote_id: this.quotation.id,
                message: null,
                msgBody: form.message_body,
                attachments: form.attached_files,
                attachmentIds: form.attachmentIds
            };

            if(this.userType == 'vendor') {
                apiUrl = window.route('send_ven_mail');

                payload = {
                    vendor_email: null,
                    vendor_id: null,
                    quote_num: this.quotation.quotation_number,
                    quote_id: this.quotation.id,
                    message: null,
                    msgBody: form.message_body,
                    attachments: form.attached_files,
                    attachmentIds: form.attachmentIds
                };
            } else {
                if(payload.customer_email == null || payload.customer_email == '') {
                    self.setErrorMessage("Customer email is not found! Please fix the customer data by editing customer info of the quote.");
                    this.setLoading(false);
                    return;
                }
            }


            return axios.post(apiUrl, payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.$emit('replyEmailSentEvent', data);
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        $('#replyModal').modal('hide');

                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
